import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {BubbleList} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(BubbleList, {
        'className': 'bubble-list-demo-basic',
        'items': this.get('items'),
        'roles': this.get('roles')
    });
};